module.exports = __webpack_public_path__ + "img/logo.7d9c0a01.png";